import { addressKeys } from '@debbie/common/dist/imports/data/properties.js';
import { Entity } from '@debbie/common/dist/index.js';
import { PropertyDataType, } from '@debbie/common/dist/properties/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { CopyToClipboard } from '../index.js';
const PropertyTypeInfo = (props) => {
    const lang = useSelector((s) => s.lang);
    const { property } = props;
    return (React.createElement("div", null,
        [Entity.Case, Entity.Customer, Entity.Creditor].includes(property.ref) && (React.createElement(React.Fragment, null,
            React.createElement("p", null,
                lang.properties.infoGuideMentions,
                ": "),
            React.createElement("p", { style: { textAlign: 'center' } },
                React.createElement("b", null,
                    "@",
                    property.label)))),
        React.createElement("p", null,
            lang.properties.infoGuideImport,
            ":"),
        property.type === PropertyDataType.address ? (React.createElement(React.Fragment, null, addressKeys.map((key) => {
            const header = `${property.label} (${
            // @ts-ignore
            lang.import[key] || key})`;
            return (React.createElement("p", { style: { textAlign: 'center' } },
                React.createElement("b", null,
                    React.createElement(CopyToClipboard, { text: header }, header))));
        }))) : (React.createElement(React.Fragment, null,
            React.createElement("p", { style: { textAlign: 'center' } },
                React.createElement("b", null,
                    React.createElement(CopyToClipboard, { text: property.handle }, property.handle)),
                ' ',
                lang.properties.or,
                ' ',
                React.createElement("b", null,
                    React.createElement(CopyToClipboard, { text: property.label }, property.label))))),
        React.createElement("p", null,
            lang.properties.infoGuideAPI,
            ":"),
        React.createElement("p", { style: { textAlign: 'center' } },
            React.createElement("b", null,
                '{',
                " \"",
                property.handle,
                "\": ",
                '<',
                "data",
                '>',
                " ",
                '}'))));
};
export default PropertyTypeInfo;
//# sourceMappingURL=PropertyTypeInfo.js.map